import { Container, Typography, Box, Alert } from "@mui/material";
import React from "react";

const Wardrobe: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
          My Wardrobe
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Organize and manage your clothing collection
        </Typography>
      </Box>

      <Alert severity="info">
        Coming soon! This page will help you catalog and organize your wardrobe.
      </Alert>
    </Container>
  );
};

export default Wardrobe;
